module.exports = __webpack_public_path__ + "media/images/sandbox/rondell/rondell-4-348e25feae4d5139e2a716faf68bb235.jpg";